var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apply-text"},[_c('p',{staticClass:"apply-icp"},[_vm._v(_vm._s(_vm.initProjectList.site_info.icp))]),_c('p',{staticClass:"apply-icp",domProps:{"innerHTML":_vm._s(_vm.initProjectList.site_info.address)}})])}
var staticRenderFns = []

export { render, staticRenderFns }